import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import RelatedLinks from "../RelatedLinks";
import { SecondAds, FirstAds, MobileUnderCalAds } from "../../Ads";
import SharedHelmet from "../Helmet";

const TITLE = "Calculez les calories brûlées en marchant";
const DESCRIPTION =
  "Calculez les calories brûlées en marchant en francais pour estimer vos indicateurs de sante rapidement. Entrez vos donnees et obtenez un resultat clair avec des reperes utiles pour le suivi quotidien.";
const KEYWORDS =
  "les calories brûlées en marchant, calculatrice les calories brûlées en marchant, calcul en ligne, sante, bien-etre, indicateurs sante, resultat rapide";
const OG_URL = "https://do-calculate.com/calculator/fr/steps-to-calories/";

function StepsToCaloriesCalculator() {
  const [weight, setWeight] = useState("");
  const [height, setHeight] = useState("");
  const [steps, setSteps] = useState("");
  const [speed, setSpeed] = useState("average");
  const [result, setResult] = useState(null);
  const [error, setError] = useState("");

  const calculateCalories = () => {
    try {
      setError("");
      if (!weight || !height || !steps) {
        throw new Error("Veuillez entrer toutes les valeurs requises");
      }

      const weightKg = parseFloat(weight);
      const heightM = parseFloat(height) / 100;
      const stepsCount = parseFloat(steps);

      if (weightKg <= 0 || heightM <= 0 || stepsCount <= 0) {
        throw new Error("Les valeurs doivent être supérieures à zéro");
      }

      let met;
      let pace;
      switch (speed) {
        case "slow":
          met = 2.8;
          pace = 0.9;
          break;
        case "average":
          met = 3.5;
          pace = 1.34;
          break;
        case "fast":
          met = 5.0;
          pace = 1.79;
          break;
        default:
          met = 3.5;
          pace = 1.34;
      }

      const stride = heightM * 0.414;
      const distance = stride * stepsCount;
      const time = distance / pace;
      const caloriesBurned = (time * met * 3.5 * weightKg) / (200 * 60);
      const caloriesPerStep = caloriesBurned / stepsCount;

      setResult({
        caloriesBurned: caloriesBurned.toFixed(2),
        caloriesPerStep: caloriesPerStep.toFixed(5),
        distance: (distance / 1000).toFixed(2),
      });
    } catch (error) {
      setError(error.message);
    }
  };

  return (
    <div className="ltr">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div className="bg-success text-white text-center" style={{ height: "50px" }}>
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>Cette calculatrice estime les calories brûlées en fonction du nombre d'étapes que vous effectuez.</p>
                <p>
                  La marche est l'exercice le plus simple car il ne nécessite aucun équipement spécial, vous n'avez pas à payer pour une adhésion coûteuse à une salle de sport, et vous pouvez le faire n'importe où.
                </p>
                <p>Pour calculer les calories brûlées, nous utilisons l'équation suivante:</p>
                <ul>
                  <li>Nous tenons compte de votre poids, de votre hauteur et de votre vitesse de marche</li>
                  <li>Nous calculons le taux métabolique (MET) en fonction de la vitesse de marche</li>
                  <li>Nous appliquons une formule scientifique qui relie les étapes aux calories brûlées</li>
                </ul>
                <p>Cette calculatrice a été développée sur la base d'études scientifiques dans le domaine du métabolisme et de l'activité physique.</p>
                <hr />
              </div>
              <br />
            </div>
            <MobileUnderCalAds />
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>{TITLE}</h2>
                </div>
                <div dir="ltr">
                  <div>
                    <hr />
                    <div className="form-group">
                      <label className="form-label ms-2" htmlFor="weight">
                        Poids (kg)
                      </label>
                      <input
                        id="weight"
                        type="number"
                        value={weight}
                        onChange={(e) => setWeight(e.target.value)}
                        placeholder="Entrez votre poids en kg"
                        className="form-control"
                        style={{ width: "75%" }}
                        min="1"
                      />
                    </div>
                    <div className="form-group">
                      <label className="form-label ms-2" htmlFor="height">
                        Hauteur (cm)
                      </label>
                      <input
                        id="height"
                        type="number"
                        value={height}
                        onChange={(e) => setHeight(e.target.value)}
                        placeholder="Entrez votre hauteur en cm"
                        className="form-control"
                        style={{ width: "75%" }}
                        min="1"
                      />
                    </div>
                    <div className="form-group">
                      <label className="form-label ms-2" htmlFor="steps">
                        Nombre de pas
                      </label>
                      <input
                        id="steps"
                        type="number"
                        value={steps}
                        onChange={(e) => setSteps(e.target.value)}
                        placeholder="Entrez le nombre de pas"
                        className="form-control"
                        style={{ width: "75%" }}
                        min="1"
                      />
                    </div>
                    <div className="form-group">
                      <label className="form-label ms-2" htmlFor="speed">
                        Vitesse de marche
                      </label>
                      <select
                        id="speed"
                        value={speed}
                        onChange={(e) => setSpeed(e.target.value)}
                        className="form-control"
                        style={{ width: "75%" }}
                      >
                        <option value="slow">Lent (3,2 km/h - 0,9 m/s)</option>
                        <option value="average">Moyen (5 km/h - 1,34 m/s)</option>
                        <option value="fast">Rapide (6,5 km/h - 1,79 m/s)</option>
                      </select>
                    </div>
                    <br />
                    <button
                      className="btn btn-success"
                      style={{ fontSize: "20px", marginLeft: "10px" }}
                      onClick={calculateCalories}
                    >
                      Calculer
                    </button>
                  </div>
                  <br />
                  {error !== "" && (
                    <p className="p-3 mb-2 bg-warning text-black">
                      Erreur: {error}
                    </p>
                  )}
                  {result && (
                    <div className="p-3 mb-2 bg-success text-white">
                      <h4>Résultats:</h4>
                      <p className="text-white">Distance parcourue: {result.distance} km</p>
                      <p className="text-white">Calories brûlées: {result.caloriesBurned} cal</p>
                      <p className="text-white">Calories par une étape: {result.caloriesPerStep} cal</p>
                    </div>
                  )}
                  <hr />
                </div>
              </div>
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>
      <div className="row" style={{ marginTop: "20px" }}>
        <div className="col-12 col-md-8">
  <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header"><h3 style={{ fontSize: "16px" }}>Conseils d'utilisation</h3></div>
              <div className="info-section-body">
                <p>Pour obtenir un resultat pertinent, verifiez vos unites, saisissez des valeurs realistes et utilisez ce calcul comme aide a la decision, puis adaptez selon votre situation.</p>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header"><h3 style={{ fontSize: "16px" }}>Pas et calories</h3></div>
              <div className="info-section-body"><p>Pour obtenir un resultat pertinent, verifiez vos unites, saisissez des valeurs realistes et utilisez ce calcul comme aide a la decision, puis adaptez selon votre situation.</p></div>
            </div>
            <div className="info-section">
              <div className="info-section-header"><h3 style={{ fontSize: "16px" }}>L'objectif des 10 000 pas</h3></div>
              <div className="info-section-body"><p>Pour obtenir un resultat pertinent, verifiez vos unites, saisissez des valeurs realistes et utilisez ce calcul comme aide a la decision, puis adaptez selon votre situation.</p></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default StepsToCaloriesCalculator;
